module.exports = __webpack_public_path__ + "img/img2.57a17514.png";